// Generated by CoffeeScript 2.7.0
var SignaturePadMixin;

import SignatureMixin from './signature.js';

export default SignaturePadMixin = {
  mixins: [SignatureMixin],
  data: function() {
    return {
      valid: true
    };
  },
  watch: {
    valid: function(new_value) {
      return this.$emit('validChanged', new_value);
    }
  },
  methods: {
    $_init: function() {
      this.canvas = this.$refs.signature_pad;
      this.signaturePad = new SignaturePad(this.canvas, {
        maxWidth: 5,
        onBegin: () => {
          this.showHelper = false;
          return this.valid = true;
        }
      });
      this.resizeCanvas();
      return window.addEventListener('resize', () => {
        this._reset();
        return this.resizeCanvas();
      }, false);
    },
    getSignature: function(callback) {
      if (this.signaturePad.isEmpty()) {
        this.valid = false;
        this.displaySignatureEmptyError();
        return false;
      } else {
        if (callback) {
          return callback();
        } else {
          return this.signaturePad.toDataURL();
        }
      }
    }
  }
};
